import HomePage from './AllOptions.vue';
import SettingPage from './SettingPage.vue';
import SupportPage from './SupportPage.vue';
import MarketingPage from './MarketingPage.vue';
import PrivacyPage from './PrivacyPage.vue';
import ShareImportPage from './ShareImportPage.vue';
import NotFoundPage from './NotFoundPage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/settings',
    name: 'Setting',
    component: SettingPage,
  },
  {
    path: '/support',
    name: 'Support',
    component: SupportPage,
  },
  {
    path: '/marketing',
    name: 'Marketing',
    component: MarketingPage,
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPage,
  },
  {
    path: '/share/:token',
    name: 'ShareImport',
    component: ShareImportPage,
  },
  // Catch-all 404 — shown for any unrecognised route (web only)
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
  },
];

export default routes;